export class SearchResourcesRequest {
    'queryText';
    'tags';
    'resourceIds';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "queryText",
            "baseName": "query_text",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "resourceIds",
            "baseName": "resource_ids",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchResourcesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
